// removed by extract-text-webpack-plugin
module.exports = {"button_group_option":"button_group_option__1eKHL"};


//////////////////
// WEBPACK FOOTER
// ./components/button-group/style.scss
// module id = X8eH
// module chunks = 13